import React from 'react'
import PortPrice from './PortPrice'
import PortSwitcher from '../port-switcher/PortSwitcher'
import EstimatedDelivery from './EstimatedDelivery'

function StepFooter (props) {
  return (
    <footer className={'step-product-footer'}>
      <div className={'step-product-footer__inputs'}>
        <div className={'step-product-footer__prices'}>
          <PortPrice vat={true} total={true}/>
          <PortPrice total={true}/>
        </div>
        <PortSwitcher/>
      </div>
      <EstimatedDelivery/>
    </footer>
  )
}

export default StepFooter